module.exports = __webpack_public_path__ + "img/sindrome_fatores_risco.de51a514.jpg";